import { render, staticRenderFns } from "./ConfirmOTP.vue?vue&type=template&id=adb59eb6&scoped=true&"
import script from "./ConfirmOTP.vue?vue&type=script&lang=js&"
export * from "./ConfirmOTP.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/authenticate/_confirm-otp.scss?vue&type=style&index=0&id=adb59eb6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb59eb6",
  null
  
)

export default component.exports